module.exports = __webpack_public_path__ + "static/fast-skeleton-pattern-dfcf158f028d71e21ad71df8419321e4.png";